import React from "react";
import { connect } from "react-redux";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from 'react-bootstrap-table2-paginator';
import { Container, Col, Fa,MDBIcon } from "mdbreact";
import { withTheme } from '../../../themes/theming';
import { withRouter } from "react-router-dom";
import { push } from "connected-react-router";
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import '../index.css';
import { getUserDetails } from "../../../actions/loginAction";
import SearchUser from "./searchUser.jsx";
import UserManageModal from "./userManageModal.jsx";
import {fetchUserSearchFields,fetchUserEmails,searchEmptyUserList,fetchUserDetails} from '../../../actions/userManagementAction'
import * as AppConst from '../../../AppConstant';
var I18n = require("react-redux-i18n").I18n;
const $ = require('jquery')
window.jQuery = $;

class MainUserContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showSearchFlag: false,
      isSearchClicked:false,
      modal: false,
      modalFor: "",
      showSearchPanel: true,
      userDto: {
        networkUserId: null,
        firstName:null,
        lastName:null,
        nmscId: null,
        tarsId: null,
        email:null,
        languageCode : null,
        emailId : null,
        role : [],
        status: null,
        adminUserLoginId: this.props.user.userMdl.username,
        adminUserLangCode: this.props.user.userMdl.lang,
        adminUserNmscCode:this.props.user.userMdl.nmsc,
        rows: 10,
        page: 1,
        programID:this.props.user.userMdl.activeProgramID,
        program: this.props.user.userMdl.activeProgram

      },
      searchDto: {
        nmscIdList: null,
        tarsId: null,
        firstName: null,
        lastName: null,
        email:null,
        roleList: null,
        statusList:null,
        adminUserType: null,
        adminUserLangCode: this.props.user.userMdl.lang,
        loggedInUser: this.props.user.userMdl.username,
        adminUserNmscCode :  this.props.user.userMdl.nmsc,
        page: 0,
        sizePerPage: 10,
        rows: 10,
      },
      data: [],
      records: 0,
      total: 0,
      sortField : null,
      sortOrder : "asc"
    };
  }
  componentWillMount() {
    if (
      this.props.user.userMdl === undefined ||
      this.props.user.userMdl === null ||
      this.props.user.userMdl.expired === undefined ||
      this.props.user.userMdl.expired
    ) {
      // get user Details from token.
      this.props.dispatch(getUserDetails());
    }
    var isNMSCAdminUser = false;
    var isTMEAdminUser = false;
    var isNotAdminUser = false; // eslint-disable-line

    if (this.props.user.userMdl.roles !== undefined) {
      var roles = this.props.user.userMdl.roles;
      for (var i = 0; i < roles.length; i++) {
        if (roles[i].toUpperCase().indexOf("NMSC") !== -1 ) {
          isNMSCAdminUser = true;
          break;
        }
        else if (roles[i].toUpperCase().indexOf("TME ADMIN") !== -1 || roles[i].toUpperCase().indexOf("TME USER") !== -1  || roles[i].toUpperCase().indexOf('KET-CEA ADMIN')!== -1 || roles[i].toUpperCase().indexOf('KET-CEA USER')!== -1 ||
            roles[i].toUpperCase().indexOf('KET-CEA BUSINESS OWNER')!== -1  || roles[i].toUpperCase().indexOf('KET-NET ADMIN')!== -1 || roles[i].toUpperCase().indexOf('KET-LEXUS ADMIN')!== -1 ||
            roles[i].toUpperCase().indexOf('KET-UC ADMIN')!== -1) {
          isTMEAdminUser = true;
            break;
        }
        isNotAdminUser = true;
      }
    }

    let userDTO = {...this.state.userDto};
    let searchDTO = {...this.state.searchDto}
    if(isTMEAdminUser){

        userDTO["adminUserType"] = "TME";

        searchDTO["adminUserType"] = "TME";
        searchDTO["isTMEAdminUser"] = isTMEAdminUser;
        this.setState({userDto:userDTO});
        this.setState({searchDto :searchDTO});
        
    }else{
 
      userDTO["adminUserType"] = "NMSC";

      searchDTO["adminUserType"] = "NMSC";
      searchDTO["isNMSCAdminUser"] = isNMSCAdminUser;
 
      this.setState({userDto:userDTO});
      this.setState({searchDto :searchDTO});  }

    // if(this.props.userManagementDetails !== null || this.props.userManagementDetails !== undefined) {
    //   this.setState({data : this.props.userManagementDetails.userManagementDTOList,
    //                 records :this.props.userManagementDetails.userManagementDTOList.records,
    //               total : this.props.userManagementDetails.userManagementDTOList.total })            
    // }  


    this.props.dispatch(fetchUserSearchFields(searchDTO));  
    if(this.props.user.userMdl.flagBRiT){
    this.props.dispatch(fetchUserEmails(searchDTO));   
    }
    if (this.props.location.query !== undefined && this.props.location.query.searchUserCriteria !== undefined) {
      searchDTO = this.props.location.query.searchUserCriteria;     
      this.setState({ searchDTO: searchDTO});
      this.props.dispatch(fetchUserDetails(searchDTO));
    }
  }

  componentWillUnmount() {
    this.setState({
      data: []
    });
    this.props.dispatch(searchEmptyUserList());
  }

  updateSearchDto = (userDTO)=>{

    this.setState({ searchDto : userDTO});

  }

  search = (userDTO) => {
    this.setState({searchDto : userDTO});
    this.setState({
      showSearchPanel: true,
      isSearchClicked:true,
      sortField : null
    });

    this.props.dispatch(fetchUserDetails(userDTO));
  };

  selectedTab = (index, label) => {
    this.setState({ selectedTab: index });
  };
  toggleSearch = toggle => {
    this.setState({
      showSearchFlag: !this.state.showSearchFlag
    });
  };
  toggleModal = action => {
    this.setState({
      modal: !this.state.modal,
      modalFor: action,
      selectedRow: {
        networkUserId: "",
        nmscId:"",
        tarsId:"",
        userName:"",
        emailId:"",
        role:[],
        languageCode:"", 
        status: "",
        userMdl: this.props.user.userMdl,
        adminLoginId: this.props.user.userMdl.username
      }
    });
    if (action === "Create") {
      const selectedRow = { ...this.state.selectedRow };
      this.setState({ selectedRow });
    }
  };

  

  delete = (networkUserId) => {
    
  }

  buttonFormatter = (cell, row) => {
    let accessType = this.props.user.userMdl.accessControl.filter(obj => obj.function === 'USER_MANAGEMENT') ? this.props.user.userMdl.accessControl.filter(obj => obj.function === 'USER_MANAGEMENT').map(a =>a.accessType) : null;
    let hasOnlyCeaRole = false
    let hasCeaRole = false
    let hasOtherRole = false
    // changes for NET
    let hasOnlyNetRole = false
    let hasNetRole = false
    let hasOtherNetRole = false
    //changes for LN
    let hasOnlyLNRole = false
    let hasLNRole = false
    let hasOtherLNRole = false

   // let dealerRow = false
    if(row.role){
        if(row.role.length>0){
          // ceaRow =row.role.filter(role=>role.toUpperCase().indexOf("KET TME") !== -1 || role.toUpperCase().indexOf("KET NMSC") !== -1 || role.toUpperCase().indexOf("KET-BRIT") !== -1 || role.toUpperCase().indexOf("KET DEALER CHAMPION") !== -1 || role.toUpperCase().indexOf("KET-BRIT DEALER CHAMPION") !== -1 ).length === 0
          
          hasCeaRole =row.role.filter(role=>role.toUpperCase().startsWith("KET-CEA")).length > 0
          hasOtherRole =row.role.filter(role=>!role.toUpperCase().startsWith("KET-CEA")).length > 0
          if(hasCeaRole && !hasOtherRole) {
            hasOnlyCeaRole = true;
          }
          //changes for NET
          hasNetRole =row.role.filter(role=>role.toUpperCase().startsWith("KET-NET")).length > 0
          hasOtherNetRole =row.role.filter(role=>!role.toUpperCase().startsWith("KET-NET")).length > 0
          if(hasNetRole && !hasOtherNetRole) {
            hasOnlyNetRole = true;
          }
           //changes for LN
           hasLNRole =row.role.filter(role=>role.toUpperCase().startsWith("KET-LEXUS")).length > 0
           hasOtherLNRole =row.role.filter(role=>!role.toUpperCase().startsWith("KET-LEXUS")).length > 0
           if(hasLNRole && !hasOtherLNRole) {
             hasOnlyLNRole = true;
           }
          //dealerRow = row.role.filter(role=>role.toUpperCase().indexOf("KET DEALER") !== -1 ||  role.toUpperCase().indexOf("KET-BRIT DEALER") !== -1 ).length === row.role.length
        }

    }
    let linkIcon = 'eye';
       return (
      <div className="btn-toolbar float-right">



          {accessType.indexOf("R/W") !== -1 && !this.props.user.userMdl.flagLN  ?
            <a onClick={() => this.toggleModal("Edit")}>
            <div title={I18n.t("tmeAdminMaster.edit")} className="edit-icon" />
          </a> : ""}
          {(accessType.indexOf("R/W") !== -1 || accessType.indexOf("R") !== -1) 
    && !this.props.user.userMdl.flagCEA && !hasOnlyCeaRole && this.props.user.userMdl.businessAreaKey !== AppConst.businessAreaKeyPer && !hasOnlyNetRole && !hasOnlyLNRole ?
          <a 
          onClick={() =>{
            this.props.dispatch(
              push({
                pathname: "/linkDealer",
                query: { selectedUser: JSON.stringify(row), 
                  searchUserCriteria: this.state.searchDto,
                  accessType : accessType }
              })
            );
          }}
          >
            
            <MDBIcon icon={"link"} fixed size="lg" title={I18n.t("Table.link")} />
          </a> : null}  
       {console.log(accessType)}

          {accessType.indexOf("R/W") !== -1 || accessType.indexOf("R") !== -1  ?
          <a 
         onClick={() => this.toggleModal("View")}
          >
            <Fa icon={linkIcon} fixed size="lg" title={I18n.t("Table.view")} />
          </a> : null}
        {/* { accessType.indexOf("R/W") !== -1 ? (
          <a onClick={() => {}}>
            <div
              title={I18n.t("tmeAdminMaster.delete")}
              className="delete-icon"
            />
          </a>
        ) : (
            ""
          )} */}
      </div>
    );
  };

  linkFormatter = (cell, row) => {
    return (
      <div className="btn-toolbar float-right">
        <a>View</a>
      </div>
    );
  };


  firstNameFormatter = (cell, row) => {
    return (
        <div style={{ textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap" }}>{row.firstName}</div>
    );
  }

  lastNameFormatter = (cell, row) => {
    return (
        <div style={{ textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap" }}>{row.lastName}</div>
    );
  }


  emailIdFormatter = (cell, row) => {
    return (
        <div style={{ textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap" }}>{row.emailId}</div>
    );
  }

  langaugeCodeFormatter = (cell, row) => {
    return (
        <div style={{ textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap" }}>{row.languageCode}</div>
    );
  }

  nmscFormatter = (cell, row) => {
    return (
      <div style={{ textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap" }}>{row.nmscId}</div>
    );
  }

  tarsIDFormatter =(cell,row)=>{
    return (
      <div style={{ textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap" }}>{row.tarsId}</div>
    );
  }

  statusFormatter(cell, row) {
    return (
      <div title={row.status && row.status !== null ? I18n.t('UserManagement.'+ row.status) : ''}>
        {I18n.t('UserManagement.' + row.status)}
      </div>
    );
  }

  pageChanged(page, sizePerPage) {
    const searchDto = { ...this.state.searchDto };
    searchDto["page"] = page;
    searchDto["rows"] = sizePerPage;
    searchDto["sizePerPage"] = sizePerPage;
    this.setState({ searchDto });
    this.search(searchDto);
  }


  handleTableChange = (type, { page, sizePerPage, sortField, sortOrder }) => {
  
    if (!sortField) {
      const currentIndex = (page - 1) * sizePerPage; // eslint-disable-line
      const searchDto = { ...this.state.searchDto };
      searchDto["page"] = page;
      searchDto["rows"] = sizePerPage;
      searchDto["sizePerPage"] = sizePerPage
      this.setState({ searchDto });
      if(this.state.isSearchClicked && this.state.records>0){
        this.props.dispatch(fetchUserDetails(searchDto));
      }
    } else if(this.state.isSearchClicked && this.state.records>0){
      if (this.state.sortOrder === "asc") {
        sortOrder = "desc";
        this.setState({ sortOrder: "desc" })
      }
      else {
        sortOrder = "asc";
        this.setState({ sortOrder: "asc" })
      }
      this.setState({ sortField: this.indexOfSortField(sortField) });
      const searchDto = { ...this.state.searchDto };
      searchDto["sortOrder"] = sortOrder
      searchDto["sortCol"] = sortField;
      this.setState({ searchDto });
      this.props.dispatch(fetchUserDetails(searchDto));
    }
  };

  indexOfSortField(sortField) {
    switch (sortField) {
      case "nmscId":
        return 1
      case "tarsId":
        return 2
      case "firstName":
        return 3
      case "lastName":
        return 4
      case "emailId":
        return 5
      case "languageCode":
        return 6
      case "status":
        return 7
      default:
          return 1
    }
  }

  
  
  componentWillReceiveProps(nextProps) {
      if(nextProps.userManagementDetails !== null){
        if(nextProps.userManagementDetails.records >0){
          this.setState({data : nextProps.userManagementDetails.userManagementDTOList});
          this.setState({ records: nextProps.userManagementDetails.records });
          this.setState({ total: nextProps.userManagementDetails.total});
         // this.setState({page : nextProps.userManagementDetails.page })
          let searchDTO = {...this.state.searchDto}
         searchDTO["page"] = nextProps.userManagementDetails.page
          this.setState({searchDto : searchDTO })
        }
        else{
          this.setState({data : []})
          this.setState({ records: 0 });
          this.setState({ total: 0 });
        }
      var index = this.state.sortField;
      if (index) {

        setTimeout(() => {
          if (this.state.sortOrder === "asc") {
            $(".searchActivityTable .dropdown").addClass("hideSortIcon");
            $(".searchActivityTable .dropup").addClass("hideSortIcon");
            $(".searchActivityTable > div > div.react-bootstrap-table > table > thead > tr > th:nth-child(" + index + ") > span > span.dropup").addClass("showSortIcon");
          }
          else {
            $(".searchActivityTable .dropdown").addClass("hideSortIcon");
            $(".searchActivityTable .dropup").addClass("hideSortIcon");
            $(".searchActivityTable > div > div.react-bootstrap-table > table > thead > tr > th:nth-child(" + index + ") > span > span.dropdown").addClass("showSortIcon");
          }
        }, 60000);
      }
    }
      else {
        this.setState({ data: [] });
        this.setState({ records: 0 });
        this.setState({ total: 0 });
      }
    }
  
  render() {
    let accessType =this.props.user.userMdl.accessControl.filter(obj => obj.function === 'USER_MANAGEMENT') ? this.props.user.userMdl.accessControl.filter(obj => obj.function === 'USER_MANAGEMENT').map(a =>a.accessType): [];   
    const columns = [
      {
        dataField: "nmscId",
        //text: I18n.t("Table.dealerName"),
        text :I18n.t("UserManagement.nmscId"),
        sort: true,
        style: { width: "7.2%", textAlign: "left" },
        headerStyle: { width: "7%", textAlign: "left" },
        formatter: this.nmscFormatter,
       // title: true
      },
      {
        dataField: "tarsId",
        // text: I18n.t("Table.city"),
        text : I18n.t("UserManagement.tarsId"),
        sort: true,
        style: { width: "21%", textAlign: "left" },
        headerStyle: { width: "20.8%", textAlign: "left" },
        formatter : this.tarsIDFormatter,
        title: true
      },
      {
        dataField: "firstName",
        //text: I18n.t("Table.toolbox"),
        text : I18n.t("UserManagement.firstName"),
        sort: true,
        style: { width: "12%", textAlign: "left" },
        formatter: this.firstNameFormatter,
        headerStyle: { width: "11.8%", textAlign: "left" },
        title: true
      },
      {
        dataField: "lastName",
        //text: I18n.t("Table.toolbox"),
        text : I18n.t("UserManagement.lastName"),
        sort: true,
        style: { width: "12%", textAlign: "left" },
        formatter: this.lastNameFormatter,
        headerStyle: { width: "11.8%", textAlign: "left" },
        title: true
      },
 

      {
        dataField: "emailId",
        //text: I18n.t("Table.toolbox"),
        text : I18n.t("UserManagement.emailId"),
        sort: true,
        style: { width: "22%", textAlign: "left" },
        formatter: this.emailIdFormatter,
        headerStyle: { width: "21.8%", textAlign: "left" },
        title: true
      },
      {
        dataField: "languageCode",
        //text: I18n.t("Table.status"),
        text : I18n.t("UserManagement.languageCode"),
        sort : true,
        formatter: this.langaugeCodeFormatter,
        style: { width: "10%",textAlign: "center" },
        headerStyle: { width: "9.8%",textAlign: "center" },
        //title: true
      },
      {
        dataField: "status",
        text: I18n.t("Table.status"),
        formatter: this.statusFormatter,
        sort: true,
        style: { width: "7%",textAlign: "center"},
        headerStyle: { width: "6.8%",textAlign: "center"}
      },
      {
        dataField: "",
        text: "",
        formatter: this.buttonFormatter,
        style: { width: "8.8%" },
        headerStyle: { width: "8.6%" }
      }
      // , {
      //     dataField: "",
      //     text: "",
      //     formatter: this.linkFormatter,
      //     // headerStyle: { width: "17%" }
      // }
    ];

    const rowEvents = {
      onClick: (e, row, rowIndex) => {
        const selectedRow = { ...this.state.selectedRow };
        selectedRow["networkUserId"] = row.networkUserId;
        selectedRow["nmscId"] = "" + row.nmscId;
        // selectedRow["dealer"] = row.dealer;
        selectedRow["tarsId"] = "" + row.tarsId;
        selectedRow["firstName"] = row.firstName;
        selectedRow["lastName"] = row.lastName;
        selectedRow["roles"] = row.role;
        selectedRow["status"] = row.status;
        selectedRow["languageCode"] = row.languageCode;
        selectedRow["userMdl"] = this.props.user.userMdl;
        selectedRow["adminNmscCode"] = this.props.user.userMdl.nmsc;
        selectedRow["adminLangCode"] = this.props.user.userMdl.lang;
        selectedRow["adminLoginId"] = this.props.user.userMdl.username;
        this.setState({ selectedRow });
      }
    };

    const { data } = this.state;
    const {sizePerPage, page}  = this.state.searchDto
    const RemotePagination = ({
      data,
      page,
      sizePerPage,
      onTableChange,
      totalSize
    }) => (
        <div className={'activityTable parent-' + this.props.theme.name}>
          <BootstrapTable
            remote
            keyField="netwoekUserId"
            noDataIndication={I18n.t('UserManagement.No User Found')}
            data={data}
            columns={columns}
            pagination={paginationFactory({ page, sizePerPage, totalSize })}
            onTableChange={onTableChange}
            rowEvents={rowEvents}
          />
        </div>
      );
   
 return (
      <Container className="mt-5 b-1 activityContainer">
        <Col md="12" className="activityTableContainer">
          <div className="activity-content">
            {/* <form className="form-horizontal"> */}
            <div className="col-md-12 row control-label noPadding">
              <label md="0.5" className={'control-label ' + this.props.theme.name + '-FontWithBold'}>
                {I18n.t("tmeAdminMaster.search")}
              </label>
              <label
                md="0.5"
                className="control-label boldFont"
                style={{ marginTop: "0.2rem" }}
              >
                <a onClick={this.toggleSearch}>
                  {this.state.showSearchFlag ? (
                    <div title={I18n.t("tmeAdminMaster.hide")} className={this.props.theme.name + "-hide-icon"} />
                  ) : (
                      <div title={I18n.t("tmeAdminMaster.show")} className={this.props.theme.name + "-show-icon"} />
                    )}
                </a>
              </label>
              <label md="0.5"  className={'control-label ' + this.props.theme.name + '-FontWithBold'} style={{width:"20%"}}>
              {I18n.t("UserManagement.user")} ({this.state.records})
              </label>
              <label className="control-label" style={{ width: "46%" }} />
              {accessType.indexOf("R/W") !==-1 && this.props.user.userMdl.flagLN!==true && this.props.user.userMdl.activeProgram !== AppConst.activeProgramLN ?
                <label
                  className="control-label boldFont"
                  style={{ textAlign: "right", width: "25%" }} >
                  {I18n.t("UserManagement.addUser")}
    
                  <a onClick={() => this.toggleModal("Create")}>
                    <div title="" className="add-icon" />
                  </a>
                </label> :""}
              <SearchUser
                flag={this.state.showSearchFlag}
                searchDto={this.state.searchDto}
                search ={this.search}
                update = {this.updateSearchDto}
              />
              <div className="col-md-12 searchActivityTable">
              {this.state.showSearchPanel ?
            <RemotePagination
             data={data}
             page={page}
             sizePerPage={sizePerPage}
             totalSize={this.state.records}
             onTableChange={this.handleTableChange}
           /> :""}
              </div>
            </div>
            {/* </form> */}
            {this.state.modal === true ? (
              <UserManageModal
                modal={this.state.modal}
                toggle={this.toggleModal}
                goTo=""
                modalFor={this.state.modalFor}
                selectedRow={this.state.selectedRow}
                searchDto={this.state.searchDto}
                userDto={this.state.userDto}
                isSearchClicked={this.state.isSearchClicked}
              />
            ) : null}
          </div>
        </Col>
      </Container>
    );
  }
}
const mapStateToProps = state => {
  return {
    user: state.loginReducer,
    blocking: state.loginReducer,
    router: state.routing,
    userManagementDetails : state.userManagementReducer.userManagementDetails
  };
};
export default withRouter(connect(mapStateToProps)(withTheme(MainUserContainer)));
